import { render } from "./productionAdd.vue?vue&type=template&id=0e046aa8&scoped=true"
import script from "./productionAdd.vue?vue&type=script&lang=js"
export * from "./productionAdd.vue?vue&type=script&lang=js"

import "./productionAdd.vue?vue&type=style&index=0&id=0e046aa8&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e046aa8"]])

export default __exports__